import type { Plan } from '@otter-ai/recall-client';
import type { CheckoutEntryPoint, PremiumFeature } from '@otter-ai/telemetry';
import { openDialog } from '@/shared/modals/openDialog';

export type OpenCCTrialDialogOptions = {
  targetPlanType: Plan['type'];
  premiumFeature?: PremiumFeature | null;
  checkoutEntryPoint?: CheckoutEntryPoint | null;
};

/**
 * Opens the CC trial modal for starting a credit card trial.
 * On success, the modal will invalidate subscription and workspace queries before closing.
 *
 * @example
 * ```tsx
 * await openCCTrialDialog({
 *   targetPlanType: 'premium',
 *   premiumFeature: PremiumFeature.allowAdvancedExport,
 *   checkoutEntryPoint: CheckoutEntryPoint.paywall,
 * });
 * ```
 */
export async function openCCTrialDialog({
  targetPlanType,
}: OpenCCTrialDialogOptions): Promise<void> {
  return openDialog<void>(async ({ done }) => {
    const { CCTrialDialog } = await import('./CCTrialDialog');
    return <CCTrialDialog done={done} targetPlanType={targetPlanType} />;
  });
}
